import React from 'react';
import PropTypes from 'prop-types';
import cx from 'bem-classnames';

import { getElementType, getUnhandledProps } from 'components/lib';

const GridItem = props => {
  const { item, className } = props;

  const ElementType = getElementType(GridItem, props);
  const rest = getUnhandledProps(GridItem, props);

  const classes = cx({ name: 'm-grid__item' }, props, className);
  return (
    <ElementType {...rest} className={classes}>
      {item}
    </ElementType>
  );
};

GridItem.propTypes = {
  className: PropTypes.string,
  item: PropTypes.any,
};

GridItem.handledProps = ['item'];

export default GridItem;
